import Action from "../base/action";

class GetTimeDuration extends Action {
    variableName;
    initialTimeVariableName;
    endTimeVariableName;
    useCurrentTimeAsEndTime;

    constructor(props) {
        super(props);
        this.variableName = props.variableName || "";
        this.initialTimeVariableName = props.initialTimeVariableName || "";
        this.endTimeVariableName = props.endTimeVariableName || "";
        this.useCurrentTimeAsEndTime = props.useCurrentTimeAsEndTime || "";
    }

    async execute(eventLoop) {
        const registry = eventLoop.training.registry;
        const startTime = registry.get(this.initialTimeVariableName);

        if (!startTime) {
            console.error("Initial timestamp variable is not set.");
            return;
        }

        let endTime = new Date();
        if (!this.useCurrentTimeAsEndTime) {
            endTime = registry.get(this.endTimeVariableName);
        }

        if (!endTime) {
            console.error("End timestamp variable is not set.");
            return;
        }

        const durationMs = endTime - startTime;
        registry.set(this.variableName, durationMs / 1000);
    }
}

export default GetTimeDuration;
